import { useSelector } from 'react-redux';
import { completed } from 'selectors/request';

const useIsRequestCompleted = (requestConst, id = 0) => {
  return useSelector((state) => completed(state, requestConst, id));
};

export default useIsRequestCompleted;
